import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import OrdersPage from './pages/OrdersPage';
import OrderDetailPage from './pages/OrderDetailPage';
import OrderFlowPage from './pages/OrderFlowPage';
import ManualOrderPage from './pages/ManualOrderPage';
import HiringPage from './pages/HiringPage';
import HiringDetailPage from './pages/HiringDetailPage';
import DeveloperPage from './pages/DeveloperPage';
import LogsPage from './pages/LogsPage';
import ProcessingHistoryPage from './pages/ProcessingHistoryPage';
import ProcessingRunDetailPage from './pages/ProcessingRunDetailPage';
import EmailSourcePage from './pages/EmailSourcePage';
import AllowlistPage from './pages/AllowlistPage';
import SettingsPage from './pages/SettingsPage';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: '#f3f4f6'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: '40px',
            height: '40px',
            border: '3px solid #e5e7eb',
            borderTopColor: '#2e7d32',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 16px'
          }} />
          <p style={{ color: '#6b7280' }}>Loading...</p>
        </div>
        <style>{`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="orders" element={<OrdersPage />} />
        <Route path="orders/new" element={<ManualOrderPage />} />
        <Route path="orders/:id" element={<OrderDetailPage />} />
        <Route path="orders/:id/flow" element={<OrderFlowPage />} />
        <Route path="hiring" element={<HiringPage />} />
        <Route path="hiring/:id" element={<HiringDetailPage />} />
        <Route path="developer" element={<DeveloperPage />} />
        <Route path="logs" element={<LogsPage />} />
        <Route path="processing" element={<ProcessingHistoryPage />} />
        <Route path="processing/:id" element={<ProcessingRunDetailPage />} />
        <Route path="emails" element={<EmailSourcePage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="settings/allowlist" element={<AllowlistPage />} />
      </Route>
    </Routes>
  );
}

export default App;
